/**
 * Amounts from the payments backend are US **dollars**, not cents, at every layer.
 * Keep that in mind when adding to this module — a helper that quietly changed
 * units would be the worst kind of bug to have near a charge.
 */
export function formatDollars(amount: number): string {
  return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}
